var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTocSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8572 4.0943H14V8.38001H8.8572V4.0943ZM5.42855 8.38001H8.8572L8.8571 12.6657H5.42855V8.38001H2V5.80856H5.42855V8.38001Z",
    fill: "#0069FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTocSvg);
export default __webpack_public_path__ + "static/media/toc_svg.8144047f0b18d8b23e239cef63c454ef.svg";
export { ForwardRef as ReactComponent };